
import { ensureStorageBuckets } from './supabaseStorage';

export const initializeApp = async () => {
  try {
    // Skip client-side bucket checks to avoid 400/403 errors
    // Buckets are now managed by migrations
    console.log('App initialization completed');
    
    return true;
  } catch (error) {
    console.error('App initialization error:', error);
    // Continue with app initialization even if storage setup fails
    return true;
  }
};
